import React from "react";

import "./Title.scss";

import yellowGermImg from "../../assets/img/germ-6.svg";
import darkBlueGermImg from "../../assets/img/germ-5.svg";
import blueGermImg from "../../assets/img/germ-2.svg";
import purpleGermImg from "../../assets/img/germ-3.svg";
import orangeGermImg from "../../assets/img/germ-1-orange.svg";
import blueGerm2Img from "../../assets/img/germ-1.svg";
import orangeGerm2Img from "../../assets/img/germ-2-orange.svg";
import orangeGerm3Img from "../../assets/img/germ-4.svg";

export default function Title() {
  return (
    <section className="wrapper">
      <div className="sticky-container--full sticky-container--title">
        <div className="title">
          <h1 className="title__heading">
            How Do Viruses Spread From <br />
            <b>Surfaces To People?</b>
          </h1>
          <div className="title__germ-wrapper">
            <div className="title__germ title__germ--blue rotate delay-random-1">
              <img src={blueGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="title__germ title__germ--yellow rotate delay-random-2">
              <img src={yellowGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="title__germ title__germ--dark-blue rotate delay-random-3">
              <img src={darkBlueGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="title__germ title__germ--orange rotate delay-random-4">
              <img src={purpleGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="title__germ title__germ--purple rotate delay-random-5">
              <img src={orangeGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="title__germ title__germ--blue2 rotate delay-random-1">
              <img src={blueGerm2Img} alt="Germ" className="img-fluid" />
            </div>
            <div className="title__germ title__germ--orange2 rotate delay-random-4">
              <img src={orangeGerm2Img} alt="Germ" className="img-fluid" />
            </div>
            <div className="title__germ title__germ--orange3 rotate delay-random-4">
              <img src={orangeGerm3Img} alt="Germ" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
